<template>
  <div class="min-h-screen bg-white p-4 sm:p-8 font-sans text-gray-700">

    <!-- 1. HEADER PRINCIPAL ESTILO MYFRAC -->
    <div class="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
      <div>
        <h1 class="text-3xl font-bold text-gray-900">Carga faciales</h1>
      </div>

      <!-- Buscador estilo píldora azul -->
      <div class="relative w-full md:w-96">
        <div style="background-color: #6ea8d4;"
          class="flex items-center rounded-full px-6 py-3 shadow-md transition-all cursor-pointer"
          @mouseenter="searchHover = true" @mouseleave="searchHover = false"
          :style="{ backgroundColor: searchHover ? '#5d9bc9' : '#6ea8d4' }">
          <svg class="w-5 h-5 text-white mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
          <input v-model.trim="search" type="text" placeholder="Buscar residente" style="background-color: transparent;"
            class="border-none text-white focus:ring-0 w-full outline-none text-base font-normal"
            :style="{ '::placeholder': { color: 'rgba(255, 255, 255, 0.8)' } }" />
        </div>
      </div>
    </div>

    <!-- Errores de carga -->
    <div v-if="failures.length" class="mb-6 rounded-xl border border-red-200 bg-red-50 px-5 py-3
         cursor-pointer shadow-sm transition
         hover:bg-red-100 hover:shadow
         focus-within:ring-2 focus-within:ring-red-400/40" @click="showFailures = !showFailures">

      <div class="w-full flex items-center justify-between gap-4 text-left">
        <div class="flex items-start gap-3">
          <svg class="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <div>
            <p class="font-semibold text-red-800 leading-tight">
              {{ failures.length }}
              {{ failures.length === 1 ? 'archivo' : 'archivos' }} con errores
            </p>
            <p class="text-sm text-red-600/80 mt-0.5">
              Revisa los detalles para corregir los problemas
            </p>
          </div>
        </div>

        <span class="text-sm font-medium text-red-700 hover:text-red-900 transition-colors flex-shrink-0">
          {{ showFailures ? 'Ocultar' : 'Ver' }}
        </span>
      </div>

      <!-- Lista de errores -->
      <ul v-if="showFailures"
        class="mt-0 space-y-2 text-sm text-red-800 border-t border-red-200 pt-4 max-h-48 overflow-y-auto">
        <li v-for="(f, i) in failures" :key="i" class="flex items-start gap-2">
          <span class="text-red-600 mt-0.5">•</span>
          <div>
            <span class="font-medium">
              {{ f.originalFilename || f.fileName || 'archivo' }}
            </span>
            <span class="text-red-700/70">
              — {{ f.notes || f.error || 'Error' }}
            </span>
          </div>
        </li>
      </ul>
    </div>

    <!-- 3. CONTENEDOR PRINCIPAL ESTILO TARJETA -->
    <div class="bg-white rounded-lg shadow-xl overflow-hidden border border-gray-200">

      <!-- HEADER AZUL DE LA TABLA -->
      <div style="background-color: #6ea8d4;" class="px-6 py-4 flex items-center justify-between shadow-md">
        <div class="flex items-center gap-3">
          <h2 class="text-xl font-bold text-white tracking-wide">
            Imágenes Registradas
          </h2>
        </div>
      </div>

      <!-- CUERPO DEL CONTENIDO -->
      <div class="p-0">

        <!-- Loading -->
        <div v-if="loading" class="p-8 space-y-4">
          <div v-for="n in 3" :key="n" class="animate-pulse flex gap-4">
            <div class="h-16 w-16 bg-gray-200 rounded-lg"></div>
            <div class="flex-1 space-y-3">
              <div class="h-4 bg-gray-200 rounded w-3/4"></div>
              <div class="h-3 bg-gray-200 rounded w-1/2"></div>
            </div>
          </div>
        </div>

        <!-- Empty State -->
        <div v-else-if="!visibleItems.length" class="p-12 text-center text-gray-500">
          <svg class="w-16 h-16 mx-auto text-gray-300 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
          <p class="font-medium text-lg">No hay imágenes</p>
          <p class="text-sm mt-2">Ajusta los filtros o busca algo diferente</p>
        </div>

        <!-- TABLA CON ESTILO MYFRAC -->
        <div v-else>
          <!-- Desktop: Tabla -->
          <div class="hidden md:block overflow-x-auto">
            <table class="w-full text-left border-collapse">
              <thead>
                <tr
                  class="text-gray-400 text-xs font-semibold uppercase tracking-wider border-b border-gray-200 bg-white">
                  <th class="px-6 py-4 w-20">FOTO</th>
                  <th class="px-6 py-4">ARCHIVO</th>
                  <th class="px-6 py-4">RESIDENTE</th>
                  <th class="px-6 py-4">ESTADO</th>
                  <th class="px-6 py-4 text-right">ACCIONES</th>
                </tr>
              </thead>
              <tbody class="text-sm text-gray-700 divide-y divide-gray-100 bg-white">
                <tr v-for="item in visibleItems" :key="item.id" class="hover:bg-gray-50 transition-colors group">

                  <!-- Foto -->
                  <td class="px-6 py-5">
                    <div
                      class="w-14 h-14 rounded-xl overflow-hidden border border-gray-200 shadow-sm group-hover:border-blue-300 cursor-pointer bg-gray-100"
                      @click="openImagePreview(item)">
                      <img v-if="item.previewUrl" :src="item.previewUrl" :alt="item.fileName"
                        class="w-full h-full object-cover">
                      <div v-else class="w-full h-full bg-gray-100 flex items-center justify-center">
                        <svg class="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                      </div>
                    </div>
                  </td>

                  <!-- Archivo -->
                  <td class="px-6 py-5">
                    <div class="font-medium text-gray-900 truncate max-w-xs" :title="item.fileName">
                      {{ item.fileName }}
                    </div>
                  </td>

                  <!-- Residente -->
                  <td class="px-6 py-5">
                    <div v-if="item.residentName">
                      <div class="font-bold text-gray-900 text-base">{{ item.residentName }}</div>
                      <div v-if="item.residentAddress" class="text-sm text-gray-500 mt-0.5 truncate max-w-xs">
                        {{ item.residentAddress }}
                      </div>
                    </div>
                    <div v-else>
                      <div class="text-sm text-gray-500 mt-0.5 truncate max-w-xs">Residente no asignado</div>
                    </div>
                    <!-- <button v-else @click="openReassign(item)"
                      class="inline-flex items-center gap-2 px-3 py-1.5 bg-gray-100 border border-gray-300 rounded text-gray-700 hover:bg-gray-200 transition-colors text-sm font-medium">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                      </svg>
                      Pendiente de asignar
                    </button> -->
                  </td>

                  <!-- Estado -->
                  <td class="px-6 py-5">
                    <span :class="getStatusClass(item)"
                      class="inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium border">
                      <span :class="getStatusDotClass(item)" class="w-2 h-2 rounded-full mr-2"></span>
                      {{ getStatusLabel(item) }}
                    </span>
                  </td>

                  <!-- Acciones -->
                  <td class="px-6 py-5 text-right">
                    <div class="flex items-center justify-end gap-2">
                      <!-- Botón Editar - Azul -->
                      <button v-if="item.status !== 'REJECTED'" @click="openReassign(item)"
                        class="w-11 h-11 rounded-full text-white flex items-center justify-center hover:scale-105 transition shadow-md"
                        style="background-color: #3b82f6;" @mouseenter="item.editHover = true"
                        @mouseleave="item.editHover = false"
                        :style="{ backgroundColor: item.editHover ? 'rgba(59, 130, 246, 0.8)' : '#3b82f6' }"
                        title="Editar asignación">
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                        </svg>
                      </button>

                      <!-- Botón Eliminar - Rojo -->
                      <button v-if="item.status !== 'REJECTED'" @click="onReject(item)"
                        class="w-11 h-11 rounded-full text-white flex items-center justify-center hover:scale-105 transition shadow-md"
                        style="background-color: #ef4444;" @mouseenter="item.deleteHover = true"
                        @mouseleave="item.deleteHover = false"
                        :style="{ backgroundColor: item.deleteHover ? 'rgba(239, 68, 68, 0.8)' : '#ef4444' }"
                        title="Eliminar">
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Mobile: Cards -->
          <div class="md:hidden p-4 space-y-3">
            <div v-for="item in visibleItems" :key="item.id" class="bg-white border rounded-lg p-4 shadow-sm">

              <div class="flex items-start gap-3 mb-3">
                <div class="w-16 h-16 rounded-lg overflow-hidden border border-gray-200 cursor-pointer"
                  @click="openImagePreview(item)">
                  <img v-if="item.previewUrl" :src="item.previewUrl" :alt="item.fileName"
                    class="w-full h-full object-cover">
                </div>

                <div class="flex-1 min-w-0">
                  <p class="font-medium text-gray-900 text-sm mb-1 truncate">{{ item.fileName }}</p>
                  <span :class="getStatusClass(item)"
                    class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border">
                    {{ getStatusLabel(item) }}
                  </span>
                </div>
              </div>

              <div class="mb-3 p-2 bg-gray-50 rounded text-sm">
                <p v-if="item.residentName" class="font-medium">{{ item.residentName }}</p>
                <p v-if="item.residentAddress" class="text-xs text-gray-600">{{ item.residentAddress }}</p>
                <p v-if="!item.residentName" class="text-gray-700 italic flex items-center gap-1">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                  </svg>
                  Pendiente de asignar
                </p>
              </div>

              <div class="flex gap-2">
                <button @click="openReassign(item)"
                  class="flex-1 px-3 py-2 text-sm text-white rounded font-medium transition-opacity"
                  style="background-color: #3b82f6;" @mouseenter="item.editHover = true"
                  @mouseleave="item.editHover = false" :style="{ opacity: item.editHover ? 0.8 : 1 }">
                  {{ item.residentName ? 'Cambiar' : 'Asignar' }}
                </button>
                <button v-if="item.status !== 'REJECTED'" @click="onReject(item)"
                  class="px-3 py-2 text-sm text-white rounded font-medium transition-opacity"
                  style="background-color: #ef4444;" @mouseenter="item.deleteHover = true"
                  @mouseleave="item.deleteHover = false" :style="{ opacity: item.deleteHover ? 0.8 : 1 }">
                  Eliminar
                </button>
              </div>
            </div>
          </div>

          <!-- Footer con paginación -->
          <div class="px-6 py-4 border-t border-gray-200 flex flex-col sm:flex-row items-center justify-between bg-white gap-4">
            <span class="text-sm text-gray-500">
              Mostrando {{ (currentPage - 1) * itemsPerPage + 1 }} - {{ Math.min(currentPage * itemsPerPage, filteredItems.length) }} de {{ filteredItems.length }} registros
            </span>
            <div class="flex items-center gap-2">
              <button @click="prevPage" :disabled="currentPage === 1"
                :class="currentPage === 1 ? 'text-gray-400 bg-gray-50 cursor-not-allowed' : 'text-gray-700 bg-white hover:bg-gray-50'"
                class="px-3 py-2 text-sm border border-gray-300 rounded-lg font-medium transition-colors flex items-center gap-1">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                </svg>
                Anterior
              </button>

              <!-- Números de página -->
              <div class="flex gap-1">
                <button v-for="page in totalPages" :key="page" @click="goToPage(page)"
                  :class="currentPage === page
                    ? 'bg-blue-600 text-white border-blue-600'
                    : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'"
                  class="w-10 h-10 text-sm border rounded-lg font-medium transition-colors">
                  {{ page }}
                </button>
              </div>

              <button @click="nextPage" :disabled="currentPage >= totalPages"
                :class="currentPage >= totalPages ? 'text-gray-400 bg-gray-50 cursor-not-allowed' : 'text-gray-700 bg-white hover:bg-gray-50'"
                class="px-3 py-2 text-sm border border-gray-300 rounded-lg font-medium transition-colors flex items-center gap-1">
                Siguiente
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de reasignación -->
    <ReassignModal v-if="reassign.open" :item="reassign.item" :busy="reassign.busy" :find-residents="findResidents"
      @close="closeReassign" @submit="onReassignSubmit" />

    <!-- Modal de preview de imagen -->
    <div v-if="imagePreview.open"
      class="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 pt-20 pb-6 px-6 cursor-pointer"
      @click="closeImagePreview">
      <div class="relative flex flex-col items-center" @click.stop>
        <span @click="closeImagePreview"
          class="absolute -top-9 -right-1 text-white text-4xl font-light cursor-pointer select-none hover:opacity-80 transition">
          &times;
        </span>
        <img :src="imagePreview.url" :alt="imagePreview.fileName"
          class="max-w-full rounded-lg shadow-2xl object-contain"
          style="max-height: 60vh; max-width: 85vw;" />
        <div class="mt-3 bg-black bg-opacity-75 text-white px-4 py-2 rounded-lg text-center max-w-md">
          <p class="font-medium text-sm truncate">{{ imagePreview.fileName }}</p>
          <p v-if="imagePreview.residentName" class="text-xs text-gray-300 mt-0.5 truncate">
            {{ imagePreview.residentName }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, computed, onMounted } from 'vue'
import orderBy from 'lodash.orderby'
import Swal from 'sweetalert2'

import ReassignModal from './ReassignModal.vue'

import {
  getIngestResult,
  patchIngestItem,
  deleteIngestItem,
  activatePhotos,
  confirmIngest,
  searchResidentsGuard
} from '@/store/facialIngest'

export default {
  name: 'IngestResultBoard',
  components: { ReassignModal },
  props: {
    token: { type: String, required: true },
    baseUrl: { type: String, default: '/api/residents/facial-recognition' },
    jobId: { type: [String, Number], required: true }
  },
  emits: ['ingest-completed', 'stats-updated'],
  setup(props, { emit }) {
    const rawItems = ref([])
    const failures = ref([])
    const loading = ref(true)
    const showFailures = ref(false)
    const searchHover = ref(false)

    const search = ref('')
    const filter = ref('ALL')
    const currentPage = ref(1)
    const itemsPerPage = 5

    const selectedIds = reactive(new Set())
    const bulkBusy = ref(false)

    const reassign = reactive({
      open: false,
      busy: false,
      item: null
    })

    const imagePreview = reactive({
      open: false,
      url: null,
      fileName: null,
      residentName: null
    })

    // ========= COMPUTEDS =========
    const readyCount = computed(() =>
      rawItems.value.filter(it => it.status === 'READY').length
    )

    const unmappedCount = computed(() =>
      rawItems.value.filter(it => it.status === 'UNMAPPED').length
    )

    const rejectedCount = computed(() =>
      rawItems.value.filter(it => it.status === 'REJECTED').length
    )

    const filteredItems = computed(() => {
      let items = rawItems.value

      // Búsqueda
      const q = (search.value || '').toLowerCase()
      if (q) {
        items = items.filter(it =>
          (it.fileName || '').toLowerCase().includes(q) ||
          (it.residentName || '').toLowerCase().includes(q) ||
          (it.residentAddress || '').toLowerCase().includes(q)
        )
      }

      // Filtro
      if (filter.value !== 'ALL') {
        items = items.filter(it => it.status === filter.value)
      }

      // Ordenar: sin asignar primero, luego rechazadas, finalmente listas
      items = orderBy(
        items,
        [
          it => it.status === 'UNMAPPED' ? 0 : (it.status === 'REJECTED' ? 1 : 2),
          it => (it.fileName || '').toLowerCase()
        ],
        ['asc', 'asc']
      )

      return items
    })

    const totalPages = computed(() => Math.ceil(filteredItems.value.length / itemsPerPage))

    const visibleItems = computed(() => {
      const start = (currentPage.value - 1) * itemsPerPage
      const end = start + itemsPerPage
      return filteredItems.value.slice(start, end)
    })

    const allVisibleSelected = computed(() => {
      if (!visibleItems.value.length) return false
      return visibleItems.value.every(it => selectedIds.has(it.id))
    })

    // ========= FUNCIONES =========
    async function loadResult() {
      loading.value = true
      try {
        const data = await getIngestResult({
          token: props.token,
          jobId: props.jobId,
          baseUrl: props.baseUrl
        })

        const items = Array.isArray(data?.items) ? data.items : []
        rawItems.value = items.map(normalizeItem)
        failures.value = Array.isArray(data?.failures) ? data.failures : []

        updateStatsEmit()
      } catch (e) {
        console.error('Error cargando:', e)
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: e.message || 'No se pudo cargar'
        })
      } finally {
        loading.value = false
      }
    }

    function normalizeItem(it) {
      const suggested = it.suggestedResident || {}
      const hasResident = !!(it.subjectUuid || suggested.residentUuid)

      // Determinar estado simplificado
      let status = 'UNMAPPED'
      if (it.reviewStatus === 'REJECTED') {
        status = 'REJECTED'
      } else if (hasResident && it.validationStatus !== 'INVALID') {
        status = 'READY'
      }

      return {
        id: it.id ?? String(Math.random()),
        fileName: it.originalFilename || it.fileName || 'archivo.jpg',
        subjectType: it.subjectType || 'RESIDENT',
        subjectUuid: it.subjectUuid || suggested.residentUuid || null,
        status,
        previewUrl: it.previewUrl || it.s3Url || null,
        residentName: suggested.residentName || null,
        residentAddress: suggested.residentAddress || null,
        notes: it.notes || null,
        activateHover: false
      }
    }

    async function onReject(item) {
      const confirmed = await Swal.fire({
        icon: 'warning',
        title: '¿Eliminar esta imagen?',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#ef4444'
      })

      if (!confirmed.value) return

      try {
        await deleteIngestItem({
          jobId: props.jobId,
          id: item.id
        })

        rawItems.value = rawItems.value.filter(it => it.id !== item.id)
        updateStatsEmit()

        Swal.fire({
          icon: 'success',
          toast: true,
          position: 'top-end',
          timer: 1500,
          showConfirmButton: false,
          title: 'Imagen eliminada'
        })
      } catch (e) {
        console.error('Error al eliminar:', e)
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: e.message || 'No se pudo eliminar la imagen'
        })
      }
    }

    function openReassign(item) {
      reassign.open = true
      reassign.item = { ...item }
    }

    function closeReassign() {
      reassign.open = false
      reassign.item = null
      reassign.busy = false
    }

    async function onReassignSubmit(payload) {
      if (!reassign.item) return
      reassign.busy = true

      try {
        await patchItem(reassign.item.id, {
          subjectType: 'RESIDENT',
          subjectUuid: payload.subjectUuid,
          reviewStatus: 'PENDING',
          status: 'READY'
        })

        const item = rawItems.value.find(it => it.id === reassign.item.id)
        if (item && payload.residentData) {
          item.residentName = payload.residentData.residentName
          item.residentAddress = payload.residentData.residentAddress
          item.status = 'READY'
        }

        closeReassign()

        Swal.fire({
          icon: 'success',
          toast: true,
          position: 'top-end',
          timer: 1500,
          showConfirmButton: false,
          title: 'Asignado correctamente'
        })
      } catch (e) {
        reassign.busy = false
        console.error('Error:', e)
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: e.message || 'No se pudo asignar'
        })
      }
    }

    async function patchItem(id, body) {
      await patchIngestItem({ id, body })
      rawItems.value = rawItems.value.map(it => (it.id === id ? { ...it, ...body } : it))
      updateStatsEmit()
    }

    function toggleSelected(id) {
      if (selectedIds.has(id)) selectedIds.delete(id)
      else selectedIds.add(id)
    }

    function toggleSelectAll() {
      if (allVisibleSelected.value) {
        visibleItems.value.forEach(it => selectedIds.delete(it.id))
      } else {
        visibleItems.value.forEach(it => selectedIds.add(it.id))
      }
    }

    function clearSelection() {
      selectedIds.clear()
    }

    async function onBulkReject() {
      if (!selectedIds.size) return

      const confirmed = await Swal.fire({
        icon: 'warning',
        title: `¿Rechazar ${selectedIds.size} imágenes?`,
        showCancelButton: true,
        confirmButtonText: 'Sí, rechazar',
        confirmButtonColor: '#ef4444'
      })

      if (!confirmed.value) return

      bulkBusy.value = true
      try {
        for (const id of Array.from(selectedIds)) {
          await patchItem(id, { reviewStatus: 'REJECTED', status: 'REJECTED' })
        }

        clearSelection()

        Swal.fire({
          icon: 'success',
          toast: true,
          position: 'top-end',
          timer: 2000,
          showConfirmButton: false,
          title: 'Imágenes rechazadas'
        })
      } catch (e) {
        console.error('Error:', e)
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: e.message || 'Error en rechazo masivo'
        })
      } finally {
        bulkBusy.value = false
      }
    }

    async function handleActivatePhotos() {
      const readyItems = rawItems.value.filter(it => it.status === 'READY')

      if (!readyItems.length) {
        Swal.fire({
          icon: 'info',
          title: 'Sin fotos listas',
          text: 'No hay imágenes listas para activar'
        })
        return
      }

      const confirmed = await Swal.fire({
        icon: 'question',
        title: `¿Activar ${readyItems.length} fotos?`,
        html: `
          <div class="text-left text-sm space-y-2">
            <p>Esta acción:</p>
            <ul class="list-disc pl-5 space-y-1">
              <li>Activará <strong>${readyItems.length} fotos</strong> en el sistema</li>
              <li>Las fotos anteriores de cada residente serán reemplazadas</li>
              <li>Las ${unmappedCount.value} sin asignar y ${rejectedCount.value} rechazadas serán omitidas</li>
            </ul>
          </div>
        `,
        showCancelButton: true,
        confirmButtonText: 'Sí, activar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#22c55e'
      })

      if (!confirmed.value) return

      loading.value = true
      try {
        const result = await activatePhotos({
          jobId: props.jobId
        })

        await Swal.fire({
          icon: 'success',
          title: '¡Fotos activadas!',
          html: `
            <div class="text-left">
              <p class="mb-2">Resultados:</p>
              <ul class="space-y-1 text-sm">
                <li>✓ ${result.activated || 0} activadas</li>
                <li>✗ ${result.rejected || 0} rechazadas</li>
                <li>⊘ ${result.skipped || 0} omitidas</li>
              </ul>
            </div>
          `,
          confirmButtonColor: '#22c55e'
        })

        emit('ingest-completed', result)

      } catch (e) {
        console.error('Error:', e)
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: e.message || 'No se pudieron activar las fotos'
        })
      } finally {
        loading.value = false
      }
    }

    async function handleConfirmIngest() {
      const readyItems = rawItems.value.filter(it => it.status === 'READY')

      if (!readyItems.length) {
        Swal.fire({
          icon: 'info',
          title: 'Sin fotos listas',
          text: 'No hay imágenes listas para cargar'
        })
        return
      }

      const confirmed = await Swal.fire({
        icon: 'question',
        title: `¿Cargar ${readyItems.length} fotos?`,
        html: `
          <div class="text-left text-sm space-y-2">
            <p>Esta acción:</p>
            <ul class="list-disc pl-5 space-y-1">
              <li>Cargará <strong>${readyItems.length} fotos</strong> en el sistema</li>
              <li>Las fotos anteriores de cada residente serán reemplazadas</li>
              <li>Las ${unmappedCount.value} sin asignar y ${rejectedCount.value} rechazadas serán omitidas</li>
            </ul>
          </div>
        `,
        showCancelButton: true,
        confirmButtonText: 'Sí, cargar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#22c55e'
      })

      if (!confirmed.value) return

      loading.value = true
      try {
        const result = await confirmIngest({
          jobId: props.jobId
        })

        await Swal.fire({
          icon: 'success',
          title: '¡Fotos cargadas!',
          html: `
            <div class="text-left">
              <p class="mb-2">Resultados:</p>
              <ul class="space-y-1 text-sm">
                <li>✓ ${result.activated || result.confirmed || readyItems.length} cargadas</li>
              </ul>
            </div>
          `,
          confirmButtonColor: '#22c55e'
        })

        emit('ingest-completed', result)

      } catch (e) {
        console.error('Error:', e)
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: e.message || 'No se pudieron cargar las fotos'
        })
      } finally {
        loading.value = false
      }
    }

    async function handleActivateSingle(item) {
      const confirmed = await Swal.fire({
        icon: 'question',
        title: '¿Activar esta foto?',
        text: `Se activará la foto de ${item.residentName}`,
        showCancelButton: true,
        confirmButtonText: 'Sí, activar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#22c55e'
      })

      if (!confirmed.value) return

      loading.value = true
      try {
        await patchIngestItem({
          id: item.id,
          body: { reviewStatus: 'APPROVED' }
        })

        // const result = await activatePhotos({
        //   jobId: props.jobId,
        //   itemIds: [item.id]
        // })

        Swal.fire({
          icon: 'success',
          toast: true,
          position: 'top-end',
          timer: 1500,
          showConfirmButton: false,
          title: 'Foto activada'
        })

        await loadResult()

      } catch (e) {
        console.error('Error:', e)
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: e.message || 'No se pudo activar la foto'
        })
      } finally {
        loading.value = false
      }
    }

    function openImagePreview(item) {
      imagePreview.open = true
      imagePreview.url = item.previewUrl
      imagePreview.fileName = item.fileName
      imagePreview.residentName = item.residentName
    }

    function closeImagePreview() {
      imagePreview.open = false
      imagePreview.url = null
      imagePreview.fileName = null
      imagePreview.residentName = null
    }

    function getStatusLabel(item) {
      const labels = {
        READY: 'Lista para activar',
        UNMAPPED: 'Pendiente de asignar',
        REJECTED: 'Rechazada'
      }
      return labels[item.status] || item.status
    }

    function getStatusClass(item) {
      const classes = {
        READY: 'bg-green-50 text-green-700 border-green-300',
        UNMAPPED: 'bg-yellow-50 text-yellow-700 border-yellow-300', // 'bg-orange-50 text-orange-800 border-orange-200', //
        REJECTED: 'bg-red-50 text-red-700 border-red-300'
      }
      return classes[item.status] || 'bg-gray-50 text-gray-700 border-gray-300'
    }

    function getStatusDotClass(item) {
      const classes = {
        READY: 'bg-green-500',
        UNMAPPED: 'bg-yellow-500', // 'bg-orange-500', // 
        REJECTED: 'bg-red-500'
      }
      return classes[item.status] || 'bg-gray-500'
    }

    async function findResidents(query) {
      const q = (query || '').trim()

      const data = await searchResidentsGuard({
        token: props.token,
        filterValue: q
      })

      const list = Array.isArray(data) ? data : []

      return list.map(r => {
        const street = r.testStreet?.name || ''
        const num = r.number || ''
        const address = street && num ? `${street} ${num}` : (street || num || '')
        const name = r.name || `${r.firstName || ''} ${r.lastName || ''}`.trim()

        return {
          value: r.uuid,
          label: address ? `${name} — ${address}` : name,
          residentName: name,
          residentAddress: address
        }
      })
    }

    function updateStatsEmit() {
      emit('stats-updated', {
        total: rawItems.value.length,
        failures: failures.value.length,
        ready: readyCount.value,
        unmapped: unmappedCount.value,
        rejected: rejectedCount.value
      })
    }

    function goToPage(page) {
      if (page >= 1 && page <= totalPages.value) {
        currentPage.value = page
      }
    }

    function nextPage() {
      if (currentPage.value < totalPages.value) {
        currentPage.value++
      }
    }

    function prevPage() {
      if (currentPage.value > 1) {
        currentPage.value--
      }
    }

    onMounted(loadResult)

    return {
      rawItems,
      failures,
      loading,
      showFailures,
      searchHover,
      search,
      filter,
      filteredItems,
      visibleItems,
      currentPage,
      totalPages,
      itemsPerPage,
      readyCount,
      unmappedCount,
      rejectedCount,
      allVisibleSelected,
      selectedIds,
      bulkBusy,
      toggleSelected,
      toggleSelectAll,
      clearSelection,
      onBulkReject,
      onReject,
      openReassign,
      closeReassign,
      onReassignSubmit,
      handleActivatePhotos,
      handleConfirmIngest,
      handleActivateSingle,
      imagePreview,
      openImagePreview,
      closeImagePreview,
      reassign,
      findResidents,
      getStatusLabel,
      getStatusClass,
      getStatusDotClass,
      goToPage,
      nextPage,
      prevPage
    }
  }
}
</script>

<style scoped>
/* Estilos para placeholder del input */
input::placeholder {
  color: rgba(255, 255, 255, 0.8);
}

/* Scroll personalizado */
.overflow-y-auto::-webkit-scrollbar {
  width: 6px;
}

.overflow-y-auto::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.overflow-y-auto::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.overflow-y-auto::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
</style>